import React from "react";
import {
  BiLogoFacebook,
  BiLogoInstagram,
  BiLogoLinkedin,
  BiLogoTwitter,
} from "react-icons/bi";

function Footer() {
  return (
    <footer className="relative overflow-hidden">
      <div className="absolute -bottom-28 left-1/2 -translate-x-1/2 text-[200px] font-bold text-[#ffffff0f] select-none">
        eCyberNest
      </div>
      <div className="flex items-start justify-between p-24 pb-48">
        <div className="flex flex-col w-2/5">
          <h1 className="mb-5 text-lg font-semibold text-white">eCyberNest</h1>
          <p className="font-medium text-xs text-[#505050] max-w-[250px]">
            eCyberNest delivers exceptional, quality products that go beyond
            expectations.
          </p>

          <div className="flex items-center space-x-4 mt-7">
            <div className="p-2 border rounded-full border-[#7F7F7F] text-[#E9E9E9]">
              <BiLogoFacebook size={18} />
            </div>
            <div className="p-2 border rounded-full border-[#7F7F7F] text-[#E9E9E9]">
              <BiLogoTwitter size={18} />
            </div>
            <div className="p-2 border rounded-full border-[#7F7F7F] text-[#E9E9E9]">
              <BiLogoInstagram size={18} />
            </div>
            <div className="p-2 border rounded-full border-[#7F7F7F] text-[#E9E9E9]">
              <BiLogoLinkedin size={18} />
            </div>
          </div>
        </div>

        <div className="flex items-start justify-between flex-1 gap-10">
          <div className="flex flex-col space-y-5">
            <h1 className="text-base text-white font-Gilroy">Service</h1>
            <p className="font-medium text-xs text-[#505050]">
              Software Development{" "}
            </p>
            <p className="font-medium text-xs text-[#505050]">Cybersecurity</p>
            <p className="font-medium text-xs text-[#505050]">
              Web Development
            </p>
            <p className="font-medium text-xs text-[#505050]">
              Mobile App Development
            </p>
            <p className="font-medium text-xs text-[#505050]">UI/UX Design </p>
          </div>

          <div className="flex flex-col space-y-5">
            <h1 className="text-base text-white font-Gilroy">Support</h1>
            <p className="font-medium text-xs text-[#505050]">Contact</p>
            <p className="font-medium text-xs text-[#505050]">Affiliate</p>
            <p className="font-medium text-xs text-[#505050]">Sitemap</p>
            <p className="font-medium text-xs text-[#505050]">Policy</p>
            <p className="font-medium text-xs text-[#505050]">Pricing</p>
          </div>

          <div className="flex flex-col space-y-5">
            <h1 className="text-base text-white font-Gilroy">Contact</h1>
            <p className="font-medium text-xs text-[#505050]">
              Addis Ababa, Bole
            </p>
            <p className="font-medium text-xs text-[#505050]">
              support@ecybernest.com
            </p>
            <p className="font-medium text-xs text-[#505050]">
              +251 94113 8614
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
